import React from 'react';
import PropTypes from 'prop-types';
import { ZCDTable } from '@zencity/common-ui';
// import TextResponses from './TextResponses';

// const otherLabel = 'Other (please specify)';

function AnalysisTable(props) {
  const { labels, counts, percentages, values } = props;
  // const hasTextResponses = labels.indexOf(otherLabel) > -1;
  const totalCount = counts.reduce((first, second) => first + second, 0);
  const tableData = labels.map((label, index) => ({
    id: label,
    labels: label,
    count: counts[index],
    percentage: `${percentages[index]}%`,
    value: values?.[index],
  }));

  const columnArray = [
    { Header: 'Answer Option', Footer: 'Total', accessor: 'labels', width: false },
    ...(values ? [{ Header: 'Cost', accessor: 'value', width: false }] : []),
    { Header: 'Count', Footer: totalCount, accessor: 'count', width: false },
    { Header: 'Percentage', accessor: 'percentage', width: false },
  ];

  return (
    <div className="engage-results-analysis-table">
      <ZCDTable columnArray={columnArray} tableData={tableData} maxItemsLimit={10} hasFooter />
    </div>
  );
}

AnalysisTable.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  counts: PropTypes.arrayOf(PropTypes.number).isRequired,
  percentages: PropTypes.arrayOf(PropTypes.number).isRequired,
  values: PropTypes.arrayOf(PropTypes.string),
};

AnalysisTable.defaultProps = {
  values: [],
};

export default AnalysisTable;
